import { useContext } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import withTheme from 'core/hocs/withTheme';
import { GlobalTopicContext } from 'core/components/GlobalTopicProvider';
import withBreakpoint from 'core/hocs/withBreakpoint';

import resolveRelationships from 'core/utils/relationships';

import SmartImage from 'core/components/SmartImage';
import TopicTopline from 'core/components/TopicTopline';
import TopicHeaderTexts from 'core/components/TopicHeaderTexts';
import ThemeSwitch from 'core/components/ThemeSwitch';
import Shapka, { StickyContainer } from 'core/components/Shapka';

import styles from './index.styl';

const relationships = resolveRelationships(['image'], null, {
  image: {
    versions: {},
  },
});


function PremiumTopicHeader(props, context) {
  const {
    theme: {
      layout,
      controls: {
        shapka: shapkaStyles,
        topicContent: topicContentAtoms,
        topicHeaderTexts: topicHeaderTextsAtoms,
      },
    },
    isPremiumInInfinity,
    isMobile,
  } = props;

  const content = useContext(GlobalTopicContext);

  const {
    is_premium: isPremiumTopic,
    ad_label: adLabel,
  } = content?.attributes || {};

  if (!isPremiumTopic) return null;

  const topic = { content };

  const {
    image: {
      versions,
      credits,
    },
  } = relationships(content) || {};

  const {
    mediaUrlPrefix,
  } = context;

  return (
    <div className={cx(isPremiumInInfinity && styles._isPremiumInInfinity)}>
      <style jsx>{`
        .${styles.premiumTopicHeader}
          .${styles._isPremiumInInfinity} &
            margin 0 -${layout.indents.right}px 0 -${layout.indents.left}px

        .${styles.titleContainer}
          :global(.desktop) &
            max-width ${topicContentAtoms.widgetsMaxWidth}px
          :global(.mobile) &
            max-width ${layout.maxWidth}

        .${styles.shapka}
          height ${shapkaStyles.height}px

        .${styles.credits}
        .${styles.premiumTitle}
          color ${topicHeaderTextsAtoms.premiumTopic.textColor}
      `}</style>
      <StickyContainer>
        <ThemeSwitch name='dark'>
          <div className={styles.premiumTopicHeader}>
            <div className={styles.shapka}>
              {!isPremiumInInfinity && <Shapka fullwidth isFirstShapkaForPremium />}
              {adLabel && (
                <div className={styles.premiumTitle}>
                  {adLabel}
                </div>
              )}
            </div>
            <div className={styles.titleWrapper}>
              <div className={styles.titleContainer}>
                <TopicTopline
                  topic={topic}
                  isPremiumTopic
                  {...!isMobile && { withPremiumTitle: true }}
                  {...mediaUrlPrefix && { path: mediaUrlPrefix }}

                />
                <TopicHeaderTexts topic={topic} isPremiumTopic />
                {credits && <div className={styles.credits}>{credits}</div>}
              </div>
            </div>
            <div className={styles.img}>
              <SmartImage
                versions={versions}
                aspectRatio={1.5}
                maxHeight={770}
              />
            </div>
          </div>
        </ThemeSwitch>
      </StickyContainer>
    </div>
  );
}

PremiumTopicHeader.contextTypes = {
  mediaUrlPrefix: PropTypes.string,
};

PremiumTopicHeader.propTypes = {
  theme: PropTypes.object,
  isMobile: PropTypes.bool,
  /**
   * Премиум топик в бесконечном скролле
   */
  isPremiumInInfinity: PropTypes.bool,
};

export default withTheme(withBreakpoint(PremiumTopicHeader));
